import {
  CaretDownFilled,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Col,
  Form,
  Input,
  notification,
  Row,
  Select,
  Space,
  Cascader as Cascaded,
  Upload,
  Dropdown,
  Menu,
  Popover,
} from 'antd'
import { TableRowSelection } from 'antd/lib/table/interface'
import { sortedIndexOf } from 'lodash'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createFalse } from 'typescript'
import { ApplicationType } from '../../app/applicationSlice'
import { RootDispatch } from '../../app/store'
import {
  DateRangeFieldName,
  DateRangeType,
  DateSelect,
} from '../../compnents/form/DateSelect'
import { PurchaseModal } from '../../compnents/importModal/purchaseModal'
import { EditableList } from '../../compnents/list/EditableList'
import { NavBar } from '../../compnents/nav/NavBar'
import { traceRoute } from '../../layouts/layoutSlice'
import {
  getTenantCategoryName,
  Tenant,
  TenantCategories,
  TenantCategory,
} from '../../models/tenant'
import { TenantQueryParams } from '../../services/tenant'
import { ThemeContext } from '../../theme/ThemeContext'
import { DataType } from '../putstorage/putstorage'
import { getVersionPageAsync } from '../versionManagement/versionManagementSlice'
import { columns } from './columns'
import { DirectoryReplicationModal } from './directoryReplicationModal'
import { ReplaceMakeModal } from './replaceMakeModal'
import { ResetSettingModal } from './resetSettingModal'
import { getPlatformIdList } from './serviceDelaySlice'
import { SettingsModal } from './SettingsModal'
import { TemplateCopyingModal } from './templateCopyingModal'
import { TenantModal } from './TenantModal'
import styles from './Tenants.module.css'
import {
  getAllList,
  getExportExcelAsync,
  getImportExcelAsync,
  getLabelList,
  getTenantList,
  selectTenantPage,
  setReplaceOpentype,
  toggleTenantState,
} from './tenantSlice'
import { VolumeSettingGrantModal } from './VolumeSettingGrantModal'
import { FilterIconOutlined } from '../../compnents/icons/Icons'
const volumeSettingList: any[] = []

interface TenantsProps {
  state: string
}

export const Tenants = ({ state }: TenantsProps): ReactElement => {
  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [popoverForm] = Form.useForm()

  const [open, setOpen] = useState(false)
  // const page = useSelector(selectTenantPage)

  const [params, setParams] = useState<TenantQueryParams>({
    current: 0,
  })

  const [tenantId, setTenantId] = useState('')

  const [versionList, setVersionList] = useState<any>([])

  const [versionName, setVersionName] = useState('')

  const [page, setPage] = useState<any>()

  const [replaceMakeId, setReplaceMakeId] = useState<number>(0)

  const [replaceMakeStatus, setReplaceMakeStatus] = useState<any>(0)

  const [tenant, setTenant] = useState<Tenant | undefined>()

  const [allList, setAllList] = useState<any[]>()

  const [isTenantModalVisible, setIsTenantModalVisible] = useState(false)

  const [
    isTemplateCopyingModalVisible,
    setIsTemplateCopyingModalVisible,
  ] = useState(false)

  const [
    isDirectoryReplicationModalVisible,
    setIsDirectoryReplicationModalVisible,
  ] = useState(false)

  // 代煎设置
  const [isReplaceMakeModalVisible, setIsReplaceMakeModalVisible] = useState(
    false
  )

  const [platformIdOptions, setPlatformIdOptions] = useState<any>([])

  const [labelList, setLabelList] = useState<any>([]) //标签数据

  const storageParams = JSON.parse(
    sessionStorage.getItem(location.pathname) || '{}'
  ) //当前页面缓存数据

  const [selectedKeys, setSelectedKeys] = useState<any>([])

  const [selectionType] = useState<'checkbox' | 'radio'>('checkbox')

  const [isPurchaseModalVisible, setIsPurchaseModalVisible] = useState(false) // 控制导入弹窗是否显示

  const rowSelection = {
    selectedRowKeys: selectedKeys,
    onSelectAll: (selected: any, selectedRows: any, changeRows: any) => {
      console.log(changeRows)

      let data: any = []
      if (selected) {
        data = [...changeRows.map((v: any) => v.id), ...selectedKeys]
      } else {
        data = selectedKeys.filter(
          (item: any) => !changeRows.some((ele: any) => ele.id === item)
        )
      }
      setSelectedKeys(data)
    },
    onSelect: (record: any, selected: any, selectedRows: any) => {
      let data: any = []
      if (selected) {
        data = [record?.id, ...selectedKeys]
      } else {
        data = selectedKeys?.filter((v: any) => v != record?.id)
      }
      setSelectedKeys(data)
    },
  }

  const [
    isVolumeSettingGrantModalVisible,
    setIsVolumeSettingGrantModalVisible,
  ] = useState(false)

  const [isResetSettingModalVisible, setIsResetSettingModalVisible] = useState(
    false
  )

  const replaceMakeList = [
    {
      value: -1,
      label: '全部',
    },
    {
      value: 1,
      label: '未开通',
    },
    {
      value: 0,
      label: '已开通',
    },
  ]

  const labelData = () => {
    dispatch(
      getLabelList({
        current: 1,
        size: 1000,
      })
    )
      .then(unwrapResult)
      .then((res) => setLabelList(res.records))
  }

  const loadData = (selectedOptions: any) => {
    const targetOption = selectedOptions[selectedOptions.length - 1]
    targetOption.loading = true
  }

  const outClued = () => {
    dispatch(
      getExportExcelAsync({
        ...params,
        area: undefined,
        provinceCode: params?.area?.slice(0, 1)[0],
        cityCode: params?.area?.slice(1, 2)[0],
        countyCode: params?.area?.slice(2, 3)[0],
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '省市区导出数据.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          navigator.msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        console.log('失败')
      })
  }

  useEffect(() => {
    if (Object.keys(storageParams).length && state == storageParams.state) {
      form.setFieldsValue({
        ...storageParams,
        labelType: storageParams?.labelType
          ?.split(',')
          ?.map((item: string) => Number(item)),
      })
    }
    form.submit()
  }, [])

  const getPage = () => {
    dispatch(
      getTenantList({
        ...params,
        _dateRange: undefined,
        area: undefined,
        provinceCode: params?.area?.slice(0, 1)[0],
        cityCode: params?.area?.slice(1, 2)[0],
        countyCode: params?.area?.slice(2, 3)[0],
        // area: params.current ? undefined : undefined,
        // provinceCode: params.current
        //   ? params?.area?.slice(0, 1)[0]
        //   : params?.area?.slice(0, 1)[0],
        // cityCode: params.current
        //   ? params?.area?.slice(1, 2)[0]
        //   : params?.area?.slice(1, 2)[0],
        // countyCode: params.current
        //   ? params?.area?.slice(2, 3)[0]
        //   : params?.area?.slice(2, 3)[0],
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        console.log(res, 'ewss')
        setPage(res)
      })
  }
  useEffect(() => {
    if (params.current) {
      getPage()
      sessionStorage.setItem(
        location.pathname,
        JSON.stringify({ ...params, state })
      )
    }
  }, [params, state])

  useEffect(() => {
    dispatch(
      getPlatformIdList({
        current: 1,
        size: 100,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setPlatformIdOptions(res.records)
      })
    labelData()
  }, [])

  useEffect(() => {
    dispatch(getAllList())
      .then(unwrapResult)
      .then((t: any) => {
        setAllList(t)
      })
  }, [])

  useEffect(() => {
    dispatch(getVersionPageAsync())
      .then(unwrapResult)
      .then((v) => {
        setVersionList(v)
      })
  }, [])

  const sortFn = (str: string) => {
    if (!str) return 'cancel'
    if (str == 'ascend') {
      return true
    } else {
      return false
    }
  }

  const onChange = (pagination: any, filters: any, sorter: any, extra: any) => {
    if (sorter.columnKey == 'createTime') {
      //开通时间
      setParams({
        ...params,
        sort:
          sortFn(sorter.order) == 'cancel'
            ? undefined
            : sortFn(sorter.order)
              ? 0
              : 1,
      })
    } else if (sorter.columnKey == 'endTime') {
      //终止时间
      setParams({
        ...params,
        sort:
          sortFn(sorter.order) == 'cancel'
            ? undefined
            : sortFn(sorter.order)
              ? 2
              : 3,
      })
    }
  }

  const menu = (
    <Menu>
      <Menu.Item
        onClick={() => {
          setIsTemplateCopyingModalVisible(true)
        }}
      >
        复制模板
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          setIsDirectoryReplicationModalVisible(true)
        }}
      >
        复制目录
      </Menu.Item>
    </Menu>
  )

  const refresh = () => {
    setSelectedKeys([])
    setParams({
      ...params,
      ...form.getFieldsValue(),
      ...popoverForm.getFieldsValue(),
      tenantCategory:
        form.getFieldsValue().tenantCategory === TenantCategory.All
          ? undefined
          : form.getFieldsValue().tenantCategory,
      labelType: form.getFieldsValue()?.labelType?.join(',') || undefined,
      current: 1,
    })
  }

  return (
    <Col
      style={{
        height: 'calc(100% - 20px) ',
        overflow: 'hidden',
        // margin: '10px 30px',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Row justify='end' style={{ marginTop: 5 }}>
        {state == '2' ? (
          <Space>
            <div
              style={{
                color: '#327aff',
                fontWeight: 'bold',
                marginRight: '10px',
              }}
            >
              已选中{selectedKeys?.length}家机构
            </div>
            {selectedKeys?.length ? (
              <Dropdown overlay={menu} trigger={['click']}>
                <Button
                  type='primary'
                  icon={<PlusOutlined />}
                  className={styles.add}
                >
                  新增目录<i className={styles.icon}></i>
                </Button>
              </Dropdown>
            ) : (
              <Button
                type='primary'
                disabled={true}
                icon={<PlusOutlined />}
                className={styles.add}
              >
                新增目录<i className={styles.icon}></i>
              </Button>
            )}

            <Button
              type='primary'
              disabled={selectedKeys?.length ? false : true}
              onClick={() => {
                setIsVolumeSettingGrantModalVisible(true)
                // setTenantId(selectIds)
              }}
            >
              重置功能
            </Button>
            <Button
              type='primary'
              disabled={selectedKeys?.length ? false : true}
              onClick={() => {
                setIsResetSettingModalVisible(true)
              }}
            >
              重置服务
            </Button>
          </Space>
        ) : (
          <Space>
            <Button
              type='primary'
              onClick={() => {
                dispatch(
                  traceRoute({
                    name: '标签管理',
                    path: '/admin/tenant/LabelManagement',
                  })
                )
              }}
            >
              标签管理
            </Button>
            <Upload
              customRequest={async ({ file, onSuccess }) => {
                if (file instanceof File) {
                  await dispatch(getImportExcelAsync({ file })).then(() => {
                    notification.success({
                      message: '导入成功',
                      duration: 3,
                    })
                    getPage()
                  })
                  onSuccess &&
                    onSuccess(null, (null as unknown) as XMLHttpRequest)
                }
              }}
              showUploadList={false}
            >
              {/* <Button type='primary' className={styles.button}>
                导入
              </Button> */}
            </Upload>
            <Button
              type='primary'
              className={styles.button}
              onClick={() => {
                setIsPurchaseModalVisible(true)
              }}
            >
              导入
            </Button>
            <Button type='primary' onClick={outClued}>
              导出
            </Button>

            <Button
              type='primary'
              icon={<PlusOutlined />}
              onClick={() => {
                setIsTenantModalVisible(true)
              }}
            >
              机构注册
            </Button>
          </Space>
        )}
      </Row>
      <Col
        style={{
          flex: 1,
          overflow: 'hidden',
          backgroundColor: theme.pn,
          marginTop: 10,
          borderRadius: 10,
          padding: '10px 15px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Form
          form={form}
          autoComplete='off'
          initialValues={{
            tenantCategory: TenantCategory.All,
          }}
          onFinish={(values) => {
            setParams({
              ...params,
              ...values,
              tenantCategory:
                values.tenantCategory === TenantCategory.All
                  ? undefined
                  : values.tenantCategory,
              labelType: values?.labelType?.join(',') || undefined,
              current: storageParams.current ? storageParams.current : 1,
            })
          }}
        >
          <Row
            justify='space-between'
            align='middle'
            style={{ marginTop: 10, marginBottom: 20, width: '100%' }}
          >
            <Space>
              <Form.Item name='name' noStyle>
                <Input
                  allowClear
                  placeholder='请输入机构名称'
                  prefix={<SearchOutlined />}
                  style={{ width: '190px' }}
                  onChange={refresh}
                />
              </Form.Item>
              <Form.Item name='tenantCategory' noStyle>
                <Select
                  suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
                  placeholder='机构类别'
                  onChange={refresh}
                  style={{ width: '160px' }}
                  dropdownClassName={styles.select}
                >
                  {TenantCategories.map((c) => (
                    <Select.Option key={c} value={c}>
                      类别-{getTenantCategoryName(c)}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name='versionId' noStyle>
                <Select
                  suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
                  placeholder='版本名称'
                  onChange={refresh}
                  style={{ width: '160px' }}
                  allowClear
                   dropdownClassName={styles.select}
                >
                  {versionList.map((v: any) => (
                    <Select.Option key={v?.id} value={v?.id}>
                      {v?.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item name='area' noStyle>
                <Cascaded
                  loadData={loadData}
                  changeOnSelect
                  suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
                  style={{ width: '170px' }}
                  options={allList}
                  onChange={refresh}
                  placeholder='请选择省市区'
                />
              </Form.Item>

              <Form.Item name='labelType' noStyle>
                <Select
                  mode='tags'
                  suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
                  placeholder='标签-全部'
                  onChange={refresh}
                  allowClear
                  style={{ width: '180px' }}
                >
                  {labelList.map((c: any) => (
                    <Select.Option key={c.id} value={c.id}>
                      {c.name}
                    </Select.Option>
                  ))}
                </Select>
                {/* <Select mode="tags" style={{ width: '100%' }} placeholder="Tags Mode" >
                  {labelList}
                </Select> */}
              </Form.Item>

              <DateSelect
                options={[
                  DateRangeType.Today,
                  DateRangeType.Yesterday,
                  DateRangeType.ThisWeek,
                  DateRangeType.ThisMonth,
                  DateRangeType.NextMonth,
                  DateRangeType.ThisYear,
                  DateRangeType.Range,
                ]}
                style={{ width: '160px' }}
                labelPrefix='终止日期-'
                placeholder='终止日期'
                namePrefix='endTime'
                onChange={refresh}
              />

              {/* <Form.Item name='openType' noStyle>
                <Select
                  suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
                  placeholder='标签-全部'
                  onChange={form.submit}
                  allowClear
                  style={{ width: '200px' }}
                >
                  {replaceMakeList.map((c) => (
                    <Select.Option key={c.value} value={c.value}>
                      代煎状态-{c.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item> */}
              <Popover
                visible={open}
                overlayClassName={styles.formQueryPopover}
                content={
                  <>
                    <Form
                      form={popoverForm}
                      onFinish={(val) => {
                        refresh()
                        setOpen(false)
                      }}
                    >
                      <Row>
                        <Col
                          className={styles.formQueryLabel}
                        >
                          合作平台：
                        </Col>
                        <Col>
                          <Form.Item label='' name='platformId'>
                            <Select
                              suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
                              placeholder='请选择合作平台'
                              style={{ width: '220px' }}
                              allowClear
                            >
                              {platformIdOptions.map((c: any) => (
                                <Select.Option key={c.id} value={c.id}>
                                  {c.platformName}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          className={styles.formQueryLabel}
                        >
                          服务状态：
                        </Col>
                        <Col>
                          <Form.Item label='' name='status'>
                            <Select
                              suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
                              placeholder='请选择服务状态'
                              allowClear
                              style={{ width: '220px' }}
                            >
                              <Select.Option value={1}>正常</Select.Option>
                              <Select.Option value={0}>已注销</Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Space
                        style={{
                          display: 'flex',
                          justifyContent: 'end',
                          marginTop: '10px',
                        }}
                      >
                        <Button
                          size='middle'
                          type={'ghost'}
                          onClick={() => {
                            setOpen(false)
                          }}
                        >
                          取消
                        </Button>
                        <Button size='middle' type='primary' htmlType='submit'>
                          确定
                        </Button>
                      </Space>
                    </Form>
                  </>
                }
                title=''
                trigger='click'
                placement='bottom'
                onVisibleChange={(v) => {
                  setOpen(v)
                }}
              >
                <Form.Item name='' initialValue={'筛选'} noStyle>
                  <Button
                    style={{
                      color: theme.tc2,
                      width: '78px',
                      textAlign: 'left',
                      // overflow: 'hidden',
                      // textOverflow: 'ellipsis',
                    }}
                    icon={
                      <FilterIconOutlined
                        style={{
                          width: '14px',
                          height: '14px',
                          position: 'relative',
                          top: 2,
                          left: -2,
                          color: '#666',
                        }}
                      />
                    }
                    onClick={() => {
                      setOpen(true)
                    }}
                  >
                    筛选
                  </Button>
                </Form.Item>
              </Popover>
            </Space>
            <Button type='primary' onClick={refresh}>
              查询
            </Button>
          </Row>
        </Form>
        <EditableList
          page={page}
          style={{ color: theme.tc3 }}
          className={styles.table}
          onChange={onChange}
          columns={columns(
            (action, t: any) => {
              switch (action) {
                case 'settings':
                  dispatch(setReplaceOpentype(t.openType))
                  setTenant(t)
                  break
                case 'toggle':
                  dispatch(toggleTenantState(t.id)).then(() => {
                    getPage()
                  })
                  break
                case 'detail':
                  setTenantId(t.id)
                  setIsTenantModalVisible(true)
                  setVersionName(t?.versionName)
                  break
                case 'openReplaceMake':
                  setReplaceMakeId(t.id)
                  // setReplaceMakeStatus(t.status)
                  setReplaceMakeStatus(t.openType)
                  setIsReplaceMakeModalVisible(true)

                  break
              }
            },
            page?.size * (page?.current - 1),
            theme
          )}
          onChangePage={(current: number, size?: number) =>
            setParams({ ...params, size, current })
          }
          rowSelection={
            state == '2'
              ? ({
                type: selectionType,
                ...rowSelection,
              } as TableRowSelection<any>)
              : undefined
          }
          onRow={(t: any) => ({
            onDoubleClick: () => {
              setTenantId(t.id)
              setVersionName(t?.versionName)
              setIsTenantModalVisible(true)
            },
          })}
        />
      </Col>
      <TenantModal
        versionName={versionName}
        tenantId={tenantId}
        visible={isTenantModalVisible}
        onCancel={() => {
          setTenantId('')
          setVersionName('')
          setIsTenantModalVisible(false)
        }}
        onOk={() => {
          setTenantId('')
          setVersionName('')
          setIsTenantModalVisible(false)
          dispatch(
            getTenantList({
              ...params,
              area: undefined,
              provinceCode: params?.area?.slice(0, 1)[0],
              cityCode: params?.area?.slice(1, 2)[0],
              countyCode: params?.area?.slice(2, 3)[0],
            })
          )
            .then(unwrapResult)
            .then((res: any) => {
              console.log(res, 'ewss')
              setPage(res)
            })
        }}
      />
      <SettingsModal
        visible={!!tenant}
        onCancel={() => {
          setTenant(undefined)
        }}
        tenantId={tenant?.id}
        tenantName={tenant?.name}
      />
      {/* 功能设置页 */}
      <VolumeSettingGrantModal
        visible={isVolumeSettingGrantModalVisible}
        onCancel={() => {
          setIsVolumeSettingGrantModalVisible(false)
        }}
        onOk={() => {
          setIsVolumeSettingGrantModalVisible(false)
          setSelectedKeys([])
          setParams({ ...params, size: 10, current: 1 })
        }}
        num={selectedKeys?.length || 0}
        tenantIds={selectedKeys}
        type={ApplicationType.Management}
      />
      <ResetSettingModal
        visible={isResetSettingModalVisible}
        tenantIds={selectedKeys}
        state={state}
        onCancel={() => {
          setIsResetSettingModalVisible(false)
        }}
        onOk={() => {
          setIsResetSettingModalVisible(false)
          setSelectedKeys([])
          setParams({ ...params, size: 10, current: 1 })
        }}
        num={selectedKeys?.length || 0}
      />
      <TemplateCopyingModal
        visible={isTemplateCopyingModalVisible}
        num={selectedKeys?.length || 0}
        tenantIds={selectedKeys}
        onCancel={() => {
          setIsTemplateCopyingModalVisible(false)
        }}
        onOk={() => {
          setSelectedKeys([])
          setIsTemplateCopyingModalVisible(false)
          setParams({ ...params, size: 10, current: 1 })
        }}
      />
      <DirectoryReplicationModal
        visible={isDirectoryReplicationModalVisible}
        num={selectedKeys?.length || 0}
        tenantIds={selectedKeys}
        onCancel={() => {
          setIsDirectoryReplicationModalVisible(false)
        }}
        onOk={() => {
          setSelectedKeys([])
          setIsDirectoryReplicationModalVisible(false)
          setParams({ ...params, size: 10, current: 1 })
        }}
      />
      {/* 代煎设置弹框 */}
      {/* <ReplaceMakeModal
        // replaceMakeId={replaceMakeId}
        // replaceMakeStatus={replaceMakeStatus}
        visible={isReplaceMakeModalVisible}
        onOk={() => {
          setReplaceMakeId(0)
          setIsReplaceMakeModalVisible(false)
          setReplaceMakeStatus(0)
          dispatch(
            getTenantList({
              ...params,
              area: undefined,
              provinceCode: params?.area?.slice(0, 1)[0],
              cityCode: params?.area?.slice(1, 2)[0],
              countyCode: params?.area?.slice(2, 3)[0],
            })
          )
        }}
        onCancel={() => {
          setReplaceMakeId(0)
          setIsReplaceMakeModalVisible(false)
          setReplaceMakeStatus(0)
        }}
      /> */}

      <PurchaseModal
        state={6}
        isPurchaseModalVisible={isPurchaseModalVisible}
        onOk={() => {
          setIsPurchaseModalVisible(false)
          getPage()
        }}
        onCancel={() => {
          setIsPurchaseModalVisible(false)
        }}
      />
    </Col>
  )
}
